import { apiRequest } from "util/services";

/** Signed, short-lived link to the Pivony for Zendesk connect page (api.pivony.com/zendesk/connect). */
export const fetchZendeskConnectLink = () =>
  apiRequest("zendesk/connect-link", "GET", null, true);

const subdomainQuery = (subdomain) =>
  subdomain ? `?subdomain=${encodeURIComponent(subdomain)}` : "";

/** Weekly root-cause report for the workspace's Zendesk connection ({connected: false} when none). */
export const fetchZendeskReport = (subdomain) =>
  apiRequest(`zendesk/report${subdomainQuery(subdomain)}`, "GET", null, true);

/** One root cause: this week vs last week, 14-day trend, sentiment and its latest tickets. */
export const fetchZendeskCause = (causeId, subdomain) =>
  apiRequest(
    `zendesk/causes/${encodeURIComponent(causeId)}${subdomainQuery(subdomain)}`,
    "GET",
    null,
    true
  );
